var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('applicable-vat-pricing',{attrs:{"errors":_vm.customErrors,"value":_vm.custom},on:{"input":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }